import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCpcKWeC-jiClLgEd3RJ6BHORTAwBT8b_4",
  authDomain: "safebytereactpwa.firebaseapp.com",
  projectId: "safebytereactpwa",
  storageBucket: "safebytereactpwa.appspot.com",
  messagingSenderId: "684648584088",
  appId: "1:684648584088:web:eef37e1f7dd9b5922851ed",
  measurementId: "G-H1R6SPPS36"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const db = getFirestore(app);

export { auth, db };